import { getGameList } from '../../../utils/neurons';

export default async function getGames(query) {
    const response = await getGameList({
        queryKey: [null, {
            search: query,
        }],
    });

    const results = response.results.map((game) => ({
        value: game.id,
        label: game.name,
    }));

    return results;
}
